if (!customElements.get('klaviyo-nl-form')) {
  customElements.define(
    'klaviyo-nl-form',
    class KlaviyoNlForm extends HTMLElement {
      constructor() {
        super();

        this.found = false;
        this.containerClass = this.dataset.container;
        this.successId = this.dataset.success;
        this.eventName = this.dataset.event;
        this.eventType = this.dataset.type;
        this.dataLayerEvent = !this.eventName
          ? null
          : {
              event: this.eventName,
              ...(this.eventType && {
                newsletter_subscription_type: this.eventType,
              }),
            };
        this.mutationObserver =
          window.MutationObserver || window.WebKitMutationObserver;
        this.container = this.getElementsByClassName(this.containerClass)[0];
        this.observer = new this.mutationObserver(
          this.onMutationObserver.bind(this),
        );

        if (this.container && this.successId) {
          this.observer.observe(this.container, {
            childList: true,
            subtree: true,
          });
        }
      }

      onMutationObserver(mutations) {
        var self = this;
        if (mutations.length && self.successId && self.container) {
          mutations.forEach(function (mutation) {
            if (
              self.container.querySelectorAll(
                'div[id*="' + self.successId + '"]',
              ).length &&
              !self.found
            ) {
              self.found = true;
              if (self.dataLayerEvent) {
                dataLayer.push(self.dataLayerEvent);
              }
              console.log(
                'Klaviyo datalayer event pushed: ',
                self.dataLayerEvent,
              );
            }
          });
        }
      }
    },
  );
}
